<template>
    <div class="modal fade" id="modal_transactions_stats" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestPayment" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        {{ i18n.t('views.clients.encaissements.by_day.title') }}

                    </h5>
                    <button @click="closeModal('modal_transactions_stats', 'view')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12 mb-4">
                            <strong>
                                {{ i18n.t('symbole.month') }} :
                            </strong> {{ i18n.t('date.month.' +
                                (defaultSearchBy?.month?.toLowerCase() ||
                                    '')) }}
                        </div>
                        <div class="col-md-6 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3>{{ i18n.t('views.clients.encaissements.table') }}</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class=" col-md-12">
                                            <div v-if="regulationsSalesList?.length"
                                                class="tab-pane fade in active show" id="members"
                                                style="overflow-x: auto;">
                                                <table class="datatables table table-striped table-bordered  ">
                                                    <thead class="thead-dark">
                                                        <tr>
                                                            <th> {{ i18n.t('symbole.day') }}</th>

                                                            <th> {{ i18n.t('symbole.year') }}</th>
                                                            <th> {{ i18n.t('tables.regulations_stats.total') }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for=" (regulation, index ) in regulationsSalesList"
                                                            value="member.id" v-bind:key="index">
                                                            <td>
                                                                {{ regulation?.day }}
                                                            </td>

                                                            <td>
                                                                {{ regulation?.year }}
                                                            </td>
                                                            <td>
                                                                {{ regulation?.amount_paid }} {{
                                                                    i18n.t('symbole.currency.mad') }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div>
                                                    <div class="d-flex align-items-center  mb-2 mt-2">
                                                        <p class="mb-0 dot-font-size">{{
                                                            i18n.t('tables.regulations_stats.total_amount')
                                                            }}
                                                        </p>
                                                        <h4>{{ totalSales }} {{ i18n.t('symbole.currency.mad') }}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <not-found :text="i18n.t('message.data_not_found.title')"
                                                    icon="warning" />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3> {{ i18n.t('views.clients.encaissements.chart') }}</h3>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-12">

                                            <div v-if="regulationsSalesList?.length > 0">
                                                <doughnut-chart :chartData="chartData" />
                                            </div>
                                            <div v-else>
                                                <not-found :text="i18n.t('message.data_not_found.title')"
                                                    icon="warning" />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>





                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent, ref, computed, toRefs, watch } from "vue";
/*plugins*/

import i18n from "@/i18n/index"
/*composables & states */
import { usePayment } from "@/composables/payment/usePayment";
import { regulations_amount_by_day, clubUUID } from '@/shared/state';
import { usePermission } from "@/composables/auth/usePermission";
import { RegulationSalesQueryParams } from '@/interfaces/stats';
import { useGlobal } from "@/composables/global/useGlobal";
import { useModal } from '@/composables/modal/useModal';

const APP_URL = process.env.VUE_APP_URL;
export default defineComponent({
    components: {},
    name: "abonnements-actifs",
    props: {
        referenceType: {
            type: String,
            default: null,
        },
        defaultSearchBy: {
            type: Object,
            default: null,
        },
        isModalOpen: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const chartLabels = ref<string[]>([]);
        const chartDatasets = ref<string[]>([]);
        const { defaultSearchBy, isModalOpen , referenceType } = toRefs(props);
        const { closeModal } = useModal();
        const searchBy = ref<RegulationSalesQueryParams>({
            id: defaultSearchBy.value.id ?? null,
            paymentDate: defaultSearchBy.value.paymentDate ?? null,
            pack_id: defaultSearchBy.value.pack_id ?? null,
            subscription_id: defaultSearchBy.value.subscription_id ?? null,
            is_renewal: defaultSearchBy.value.is_renewal ?? null,
            clubUUID: clubUUID.value,
            paymentMethod: defaultSearchBy.value.paymentMethod ?? null,
            bankName: defaultSearchBy.value.bankName ?? null,
            memberUUID: defaultSearchBy.value.memberUUID ?? null,
            memberMatricule: defaultSearchBy.value.memberMatricule ?? null,
            isActive: defaultSearchBy.value.isActive ?? null,
            month: defaultSearchBy.value.month ?? null,
            year: defaultSearchBy.value.year ?? null,
            byDay: "true",
            type: "all",
            page: defaultSearchBy.value.page ?? null,
            limit: defaultSearchBy.value.limit ?? null,
            reference_type: defaultSearchBy.value.reference_type ?? null,
            reference_id: defaultSearchBy.value.reference_id ?? null,
        });


        const { fetchRegulationsStatsByDay, isRequestPayment } = usePayment();
        const { hasPermission } = usePermission();

        const regulationsSalesList = computed(() => regulations_amount_by_day.data);
        const totalSales = computed(() => regulations_amount_by_day.total);
        const chartData = computed(() => {

            regulationsSalesList.value.forEach((e: any) => {
                if (e) {
                    chartLabels.value.push(e.day)
                    chartDatasets.value.push(e.amount_paid)
                }

            })
            const data = {
                labels: chartLabels.value,
                datasets: [
                    {
                        data: chartDatasets.value,
                        backgroundColor: ['#77CEFF', '#0079AF', '#123E6B', '#97B0C4', '#A5C8ED'],
                    }
                ],
            }
            return data
        });

        const fetchRegulationsStatsByDayData = () => {
            chartLabels.value = []
            chartDatasets.value = []
            searchBy.value.month = defaultSearchBy.value.month_key ?? null
            searchBy.value.year = defaultSearchBy.value.year ?? null
            searchBy.value.reference_type = defaultSearchBy.value.reference_type ?? null
            searchBy.value.is_renewal = defaultSearchBy.value.is_renewal ?? null
            fetchRegulationsStatsByDay(searchBy.value);
        };


        watch(() => defaultSearchBy.value , (newValue) => {
            if (newValue)
                fetchRegulationsStatsByDayData()
        }, { deep: true, immediate: true });
        return {
            regulationsSalesList,
            totalSales,
            fetchRegulationsStatsByDayData,
            i18n,
            chartLabels,
            chartDatasets,
            chartData,
            APP_URL,
            clubUUID,
            hasPermission,
            isRequestPayment,
            closeModal
        };
    },
});
</script>
